(ns ncr.etc.profile-pspec
  (:require
   [ncr.etc.profile :as p]))

(def search-blur-sensitive
  [:local "ui/search/blur-sensitive"])

(def use-search-blur-sensitive
  (partial p/use-profile search-blur-sensitive false))

(def use-fragment-history-show-all
  (partial p/use-profile [:local "ui/fragment/history/show-all"] false))

(def use-fragment-history-full-dates
  (partial p/use-profile [:local "ui/fragment/history/full-dates"] false))

(def timesheet-settings
  [:remote "ui/properties/timesheet"])

(def use-timesheet-settings
  (partial p/use-profile timesheet-settings {}))

(def search-group-by
  [:local "ui/search/group-by"])

(def use-search-group-by
  (partial p/use-profile search-group-by
    {:default {:mode :date :no-date-last? false}}))

(def search-scroll-top
  [:session "ui/search/scroll-top"])

(def demo-data-accepted
  [:local "ui/demo/data-accepted"])

(def read-demo-data-accepted!
  (partial p/read-profile! demo-data-accepted))

(def write-demo-data-accepted!
  (partial p/write-profile! demo-data-accepted))

(def use-scratch-selected
  (partial p/use-profile [:local "ui/scratch/selected"]))
